import React, { useState } from "react";
import AIChatbotSettingsTab from "./AIChatbotSettingsTab";

interface Props {
  selectedTab: string;
}

export default function AIChatbotTrainingSettingsTabs(props: Props) {
  return (
    <div className="flex justify-center border-b-2 border-slate-200 mb-4 top-9 sticky z-40 w-full bg-slate-gray-50">
      <AIChatbotSettingsTab
        title="Index"
        route={`/bots/training/index`}
        selected={props.selectedTab === "Index"}
      />
      <AIChatbotSettingsTab
        title="Web Training"
        route={`/bots/training/web`}
        selected={props.selectedTab === "Web Training"}
      />
      <AIChatbotSettingsTab
        title="File Training"
        route={`/bots/training/file`}
        selected={props.selectedTab === "File Training"}
      />
      {/* <AIChatbotSettingsTab
        title="Collect Data"
        route={`/ai/settings/data/${props.aiConfigId}`}
        selected={props.selectedTab === "Collect Data"}
      />
      <AIChatbotSettingsTab
        title="Starter Questions"
        route={`/ai/settings/questions/${props.aiConfigId}`}
        selected={props.selectedTab === "Starter Questions"}
      />
      <AIChatbotSettingsTab
        title="Test"
        route={`/ai/settings/test/${props.aiConfigId}`}
        selected={props.selectedTab === "Test"}
      /> */}
    </div>
  );
}
